import { PDFConfig } from "../types/pdf-types";

export const PDF_CONFIG: PDFConfig = {
  columnStyles: {
    0: { cellWidth: 10 },
    1: { cellWidth: 31 },
    2: { cellWidth: 29 },
    3: { cellWidth: 25 },
    4: { cellWidth: 28 },
    5: { cellWidth: 15 },
    6: { cellWidth: 20 },
    7: { cellWidth: 38 }
  },
  tableColumns: [
    { header: "No.", dataKey: "no" },
    { header: "No. STT", dataKey: "ddSttNo" },
    { header: "No. referensi", dataKey: "ddRefNo" },
    { header: "Jenis pengiriman", dataKey: "ddProductType" },
    { header: "No. DEM", dataKey: "ddDemNo" },
    { header: "Total koli", dataKey: "ddPieces" },
    { header: "Ursa code", dataKey: "ddDestinationUrsaCode" },
    { header: "Alasan gagal", dataKey: "ddScanStatus" }
  ]
};